import { TypeformSnippet } from 'components/shared';
import styles from './UltrasignalTF.module.css';

export const UltraSignalTFModal = ({
  className,
  trackingParams,
}: {
  className?: string;
  trackingParams?: {
    utm_source?: string;
    utm_medium?: string;
    utm_campaign?: string;
  };
}) => {
  return (
    <div className={`${styles.root}${className ? ` ${className}` : ''}`}>
      <TypeformSnippet
        typeformId="WwKw67nO"
        frameTitle="Apply for Ultrasignal"
        className={styles.typeformContainer}
        trackingParams={trackingParams}
      />
    </div>
  );
};
